import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import axios from 'axios';
import merge from 'merge-options-es5';
import { AvProxy } from '@availity/api-core';

var AvProxyApi =
/*#__PURE__*/
function (_AvProxy) {
  _inheritsLoose(AvProxyApi, _AvProxy);

  function AvProxyApi(options) {
    return _AvProxy.call(this, {
      http: axios,
      promise: Promise,
      merge: merge,
      config: options
    }) || this;
  }

  return AvProxyApi;
}(AvProxy);

export { AvProxyApi as default };